import { useEffect } from 'react';

import { post } from 'lib/request';
import { isProduction, log } from 'lib/utils';

const postView = (key, domain) => post(`/${domain}/${key}/view`);

/**
 * `dangerouslyForceRequest` will send a request to the actual backend.
 * If using the production API in development, it will count as an user
 * view, possibly inflating this metric.
 */
function useSendPageView(
  key,
  domain,
  { deps = [], dangerouslyForceRequest = false, enabled = true } = {
    deps: [],
    dangerouslyForceRequest: false,
    enabled: true,
  }
) {
  useEffect(() => {
    if (!dangerouslyForceRequest && enabled) {
      if (!isProduction()) {
        log(
          'dev',
          `In production mode, a POST request will be sent to the following API endpoint: /${domain}/${key}/view/`
        );

        return;
      }

      postView(key, domain);
    }
  }, [key, domain, enabled, ...deps]);
}

export default useSendPageView;
